/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDirection = createReactComponent("direction", "IconDirection", [
  ["path", { d: "M9 10l3 -3l3 3", key: "svg-0" }],
  ["path", { d: "M9 14l3 3l3 -3", key: "svg-1" }]
]);

export { IconDirection as default };
//# sourceMappingURL=IconDirection.js.map
